var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.31366C14.0023 9.19357 13.7967 10.0616 13.4 10.847C12.9296 11.7882 12.2065 12.5798 11.3116 13.1332C10.4168 13.6866 9.3855 13.9799 8.33333 13.9803C7.45342 13.9826 6.58541 13.777 5.8 13.3803L2 14.647L3.26667 10.847C2.86995 10.0616 2.66437 9.19357 2.66667 8.31366C2.66707 7.2615 2.96041 6.23023 3.51381 5.33536C4.06722 4.44049 4.85884 3.71737 5.8 3.24699C6.58541 2.85028 7.45342 2.6447 8.33333 2.64699H8.66667C10.0562 2.72365 11.3687 3.31017 12.3528 4.29423C13.3368 5.2783 13.9233 6.59076 14 7.98033V8.31366Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/MessageCircle.1a21ff62d394053b50925afbd1c28fea.svg";
export { ForwardRef as ReactComponent };